import _ from 'lodash';
import eneTracker from '../../services/eneTracker';
import EneTracker from '../../model/EneTracker';

const state = {
  baseUrl: '/eneTracker',
  eneTrackerList: [],
  images: [],
  complain: null,
  pagination: {},
  loading: false,
  downloadList: [],
  creditNote: null
};

const actions = {
  list({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setEneTrackerList', { eneTrackerList: [], pagination: {} });

    commit('startRequest');
    eneTracker
      .list({ query })
      .then(response => {
        commit('setEneTrackerList', { eneTrackerList: response.data.rows, pagination: response.data.pagination });
      })

      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getCreditNoteByArticle({ dispatch, commit }, { articleCode, storeId, billNumber, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    eneTracker
      .getCreditNoteByArticle({ articleCode, storeId, billNumber })
      .then(response => {
        commit('setCreditNote', { creditNote: response.data || null });
      })
      .catch(e => {
        commit('setCreditNote', { creditNote: null });
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { complain, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    eneTracker
      .postOne({ complain })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'New complain List has been added.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
          commit('setEnETrackerImages', { images: [] });
        }
      })
      .catch(e => {
        dispatch('alert/clear', {}, { root: true });
        dispatch(
          'alert/error',
          {
            showType: 'dialog',
            position: 'center',
            title: '',
            text: 'Something went wrong'
          },
          { root: true }
        );
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  download({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setDownloadComplainList', { downloadList: [] });

    // Do not toggle shared `loading` — that drives the list table spinner.
    eneTracker
      .list({ query })
      .then(response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'Preparing your download, please wait...'
          },
          { root: true }
        );
        commit('setDownloadComplainList', {
          downloadList: response.data.rows
        });
      })

      .catch(e => {
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { type = 'transactionComplain', complain, router, id, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    eneTracker
      .patchOne({ type, complain, id })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: type === 'transactionComplain' ? 'Complain has been updated.' : 'Complain has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setComplain', { complain: {} });
    eneTracker
      .getOne({ id })
      .then(response => {
        commit('setComplain', { complain: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { type = 'list', id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    eneTracker
      .deleteOne({ type, id })
      .then(_response => {
        dispatch('list', { id });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: type === 'list' ? 'Complain has been deleted.' : 'Complain has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  uploadEnETrackerImage({ dispatch, commit }, query = {}, router) {
    dispatch('alert/clear', {}, { root: true });
    const { file } = query;
    return eneTracker
      .getEnETrackerSignedUrl({ filename: file.name, filetype: file.type })
      .then(response => {
        return eneTracker
          .uploadEnETrackerImage({ url: response.data, file })
          .then(_res => {
            dispatch(
              'alert/success',
              {
                showType: 'toast',
                position: 'center',
                title: '',
                text: 'Image uploaded successfully'
              },
              { root: true }
            );
            commit('setEnETrackerImages', { images: response.data });
            return { success: true, data: response.data };
          })
          .catch(e => {
            commit('requestFailed');
            dispatch('common/handleServiceException', { e, router }, { root: true });
            throw e;
          });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
        throw e;
      });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setEneTrackerList(state, { eneTrackerList, pagination }) {
    let row = 1;
    state.eneTrackerList = _.map(eneTrackerList, complain => {
      const newEneTracker = new EneTracker({
        id: complain._id, // eslint-disable-line
        index: row,
        articleCode: complain.articleCode,
        storeName: complain.storeName,
        articleDescription: complain.articleDescription,
        complainNumberSharedByBrand: complain.complainNumberSharedByBrand,
        customerMobileNumber: complain.customerMobileNumber,
        cnQuantity: complain.cnQuantity,
        replacementTagNumber: complain.replacementTagNumber,
        complainDateWithBrand: complain.complainDateWithBrand,
        invoiceDate: complain.invoiceDate,
        imagesUrl: complain.imagesUrl,
        invoiceNumber: complain.invoiceNumber,
        storeid: complain.storeid,
        issueWithProduct: complain.issueWithProduct,
        issueResolved: complain.issueResolved,
        createdAt: complain.createdAt,
        complaintAge: complain.complaintAge
      });
      row += 1;
      return newEneTracker;
    });

    state.pagination = pagination;
    state.loading = false;
  },
  setComplain(state, { complain }) {
    state.complain = new EneTracker({
      id: complain._id,
      articleCode: complain.articleCode,
      storeName: complain.storeName,
      articleDescription: complain.articleDescription,
      complainNumberSharedByBrand: complain.complainNumberSharedByBrand,
      customerMobileNumber: complain.customerMobileNumber,
      cnQuantity: complain.cnQuantity,
      replacementTagNumber: complain.replacementTagNumber,
      complainDateWithBrand: complain.complainDateWithBrand,
      invoiceDate: complain.invoiceDate,
      invoiceNumber: complain.invoiceNumber,
      storeid: complain.storeId,
      imagesUrl: complain.imagesUrl,
      issueWithProduct: complain.issueWithProduct,
      issueResolved: complain.issueResolved,
      createdAt: complain.createdAt,
      complaintAge: complain.complaintAge
    });
    state.loading = false;
  },
  setDownloadComplainList(state, { downloadList }) {
    let row = 1;
    state.downloadList = _.map(downloadList, complain => {
      const newEneTracker = new EneTracker({
        id: complain._id, // eslint-disable-line
        index: row,
        articleCode: complain.articleCode,
        storeName: complain.storeName,
        articleDescription: complain.articleDescription,
        complainNumberSharedByBrand: complain.complainNumberSharedByBrand,
        customerMobileNumber: complain.customerMobileNumber,
        cnQuantity: complain.cnQuantity,
        replacementTagNumber: complain.replacementTagNumber,
        complainDateWithBrand: complain.complainDateWithBrand,
        invoiceDate: complain.invoiceDate,
        invoiceNumber: complain.invoiceNumber,
        storeid: complain.storeid,
        issueWithProduct: complain.issueWithProduct,
        issueResolved: complain.issueResolved,
        createdAt: complain.createdAt,
        complaintAge: complain.complaintAge
      });
      row += 1;
      return newEneTracker;
    });
    // state.pagination = pagination;`
    state.loading = false;
  },
  setCreditNote(state, { creditNote }) {
    state.creditNote = creditNote;
    state.loading = false;
  },
  setEnETrackerImages(state, { images }) {
    if (Array.isArray(state.images)) {
      state.images.push(images.split('?')[0]);
    } else {
      state.images = [];
    }
  },
  setBillImages(state, { images }) {
    state.images = Array.isArray(images) ? images : [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
